import { useState, useEffect } from "react";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import { Navbar, NavbarList } from "~/components/navbar";
import threadIcon from "~/assets/thread.svg";
import Reset from "~/components/auth/reset";

export default function PasswordResetPage() {
  return (
    <>
      <Head>
        <title>Reset Password for Threads</title>
      </Head>
      <div className="min-h-screen w-full flex flex-col items-center">
        <Navbar className="max-w-7xl py-6 px-4 md:px-6">
          <NavbarList>
            <Link
              href="/"
              className="flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-300 rounded-sm"
              title="threads"
            >
              <img className="h-6 w-auto inline" src={threadIcon} alt="home" />
              <span className="font-bold text-black text-base tracking-tight">
                threads
              </span>
            </Link>
          </NavbarList>
        </Navbar>
        <Reset className="mt-10 md:mt-20" />
      </div>
    </>
  );
}
